export const getDateInputValue = (value?: string | null) =>
  typeof value === 'string' ? value.slice(0, 10) : ''

export const isPostAvailable = (available_to?: string | null) =>
  !available_to || available_to >= getDateInputValue(new Date().toISOString())
